// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__O7PDY","content":"styles_content__340v5","checkbox":"styles_checkbox__3CB-G","checkboxLabel":"styles_checkboxLabel__1saEV"};